// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1064":"b62a85ad","3665":"662a76c0","8493":"17f6bf6c"}[chunkId] + ".chunk.css";
};